import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { mapServiceTypes } from '../../../../../utils/publishTerms';
import { IServicePeriod, IServicePackage } from '../../../../reducers';

export function mapPublishTerm(publishOption: IServicePeriod | IServicePackage): ICheckPublishTermSchema {
  const { type, days, tariffIdentificator, token } = publishOption;
  const { serviceTypes } = tariffIdentificator;

  const services = mapServiceTypes(serviceTypes);

  return {
    type,
    days,
    tariffIdentificator,
    services,
    token,
  };
}
